import { render, staticRenderFns } from "./PaidView.vue?vue&type=template&id=dfb64790&scoped=true&"
import script from "./PaidView.vue?vue&type=script&lang=js&"
export * from "./PaidView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb64790",
  null
  
)

export default component.exports